/**
 * Environment configuration constants for Datadog RUM initialization
 */

/**
 * Allowlist of environments where Datadog RUM should be enabled
 * All other environments will have RUM disabled to reduce monitoring costs
 */
export const RUM_ENABLED_ENVIRONMENTS: readonly string[] = ['staging', 'prod'];

/**
 * Determines if Datadog RUM should be enabled for the given environment
 * @param environment - The deployment environment name (from hostname detection)
 * @returns true if RUM should be initialized, false otherwise
 */
export const isRumEnabled = (environment: string | undefined): boolean => {
  if (!environment) {
    return false; // Default safe: no environment = no RUM
  }
  return RUM_ENABLED_ENVIRONMENTS.includes(environment.toLowerCase());
};
